import { render, staticRenderFns } from "./carparkspace.vue?vue&type=template&id=56057f5a&"
import script from "./carparkspace.vue?vue&type=script&lang=js&"
export * from "./carparkspace.vue?vue&type=script&lang=js&"
import style0 from "./carparkspace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports